<div class="relative">
    <div *ngIf="!chartData || !chartData.length" class="h-[100%] absolute top-0 left-0 w-full flex justify-center items-center">
        <p class="font-bold" i18n="@@no_data_to_show">No Data To Show</p>
    </div>
    <div #echarts echarts [options]="options" theme="macarons" class="demo-chart"></div>
    <div #echarts2 echarts [options]="options2" theme="macarons" class="hidden"></div>
    <app-chart-paginator [currentPage]="currentPage" [totalPages]="totalPages" (updateActionEmit)="updateChartData($event)"></app-chart-paginator>
    <label *ngIf="hasCurrencySymbol" class="absolute top-0 left-0 unit-label">{{currencyFormatter.getCurrencySymbol()}}{{this.scale.unit}}</label>
    <label *ngIf="!hasCurrencySymbol" class="absolute top-0 left-0 unit-label">{{this.scale.unit}}</label>
</div>